<script setup lang="ts">
import { useNotification, VIcons } from '@/shared/ui'
import './assets/style.scss'
import { type PropType, ref } from 'vue'
import { useTranslate } from '@/shared/lib'

const props = defineProps({
  size: {
    type: Number,
    default: 20,
  },
  copyDataFunc: {
    type: Function as PropType<() => string>,
    default: undefined,
  },
})

const { addSuccess, addError } = useNotification()
const { trs } = useTranslate()

const copy = ref<HTMLElement>()

/**
 * Функция копирования текста
 */
const clickHandler = () => {
  if (!copy.value) return

  const text =
    (props?.copyDataFunc && props.copyDataFunc()) || copy.value.textContent || copy.value.innerText

  try {
    navigator.clipboard.writeText(text)
    addSuccess(trs('itf.copy_text'))
  } catch (e: any) {
    addError(trs('itf.copy_text_error'))
  }
}
</script>

<template>
  <div class="copy__wrapper">
    <span ref="copy">
      <slot />
    </span>

    <VIcons
      class="copy__icon"
      type="content_copy"
      :style="{ fontSize: `${size}px` }"
      @click="clickHandler"
    />
  </div>
</template>
